import React from 'react';
import {Field} from 'redux-form/immutable';
import {TextAreaField} from 'redux-form-antd'
import {
    required,
} from "../validDesc";

const minLength20 = value => {
    if (!value) return undefined;
    const text = value.toString().trim();
    if (text.length === 0) return undefined;
    return text.length < 20 ? '最少請輸入 20 字' : undefined;
};

const requiredAndMinLength20 = [required, minLength20];

const SseQAll = props => {
    return (
        <div>
            <Field validate={requiredAndMinLength20} component={TextAreaField} label='貴子弟在行為與態度上的特點：' name="sse_q1" rows="3"/>
            <Field validate={requiredAndMinLength20} component={TextAreaField} label='貴子弟在身心發展上要導師知道的情況：' name="sse_q2" rows="3"/>
            <Field validate={requiredAndMinLength20} component={TextAreaField} label='在生活規範或課業上，需要您我共同配合的特點：' name="sse_q3" rows="3"/>
            <Field validate={requiredAndMinLength20} component={TextAreaField} label='孩子在行為與態度偶爾有狀況時，您的管教…' name="sse_q4" rows="3"/>
        </div>
    )
}

export default SseQAll



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/TransferStudentContaioner/TransferStudentForm/SseQAll.jsx